module.exports = __webpack_public_path__ + "static/img/bannerdefault.fd86be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bannerdefault.jpg
// module id = t4Q8
// module chunks = 48